import React from "react";
import { connect, Provider } from "react-redux";
import * as actions from "../../actions/actions";
import store from "../../stores/reduxStore.js";

class WelcomeModalTriggerUnwrapped extends React.Component {
    componentDidMount() {
        this.props.showModal(null, "WELCOME_MODAL", this.props);
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state, { args }) => ({
    team: args.team,
    hasPremiumAccount: args.has_premium_account
});

const ConnectedWelcomeModalTrigger = connect(
    mapStateToProps,
    { showModal: actions.showModal }
)(WelcomeModalTriggerUnwrapped);

export default function WelcomeModalTrigger(props) {
    return (
        <Provider store={store}>
            <ConnectedWelcomeModalTrigger {...props} />
        </Provider>
    );
}
